import { combineReducers } from "redux";
import auth from "./auth.reducer";
import settings from "./settings.reducer";
import thankyou from "./thankyou.reducer";

// to combine all reducers together
const appReducer = combineReducers({
  auth,
  settings,
  thankyou,
});

export default appReducer;
